var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{class:['ztree', { 'ztree-disabled': this.isReadOnly }],style:(_vm.contentCss),attrs:{"id":_vm.ztreeId}}),_vm._v(" "),_vm._t("context-menu")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }